
import { useAuth } from '@/contexts/AuthContext';
import NavLogo from './NavLogo';
import NavLinks from './NavLinks';
import SearchBar from './SearchBar';
import UserMenu from './UserMenu';
import AuthButtons from './AuthButtons';
import MobileNav from './MobileNav';
import DashboardNavLink from './DashboardNavLink';
import NavSeparator from './NavSeparator';

const NavbarContent = () => {
  const { user } = useAuth();

  return (
    <div className="max-w-7xl mx-auto flex items-center justify-between">
      <div className="flex items-center gap-8">
        <NavLogo />
        <div className="hidden lg:flex">
          <NavLinks />
        </div>
      </div>
      
      <div className="flex items-center gap-3">
        {/* Desktop elements - hidden on mobile/tablet, shown on large screens and above */}
        <div className="hidden lg:flex items-center gap-3">
          <NavSeparator />
          <SearchBar />
          <NavSeparator />
          <DashboardNavLink />
          {user ? <UserMenu /> : <AuthButtons />}
        </div>
        
        {/* Mobile/Tablet navigation - shown on mobile and tablet, hidden on large screens and above */}
        <div className="flex lg:hidden">
          <MobileNav />
        </div>
      </div>
    </div>
  );
};

export default NavbarContent;
